'use client';

import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';

import { MdOutlineShoppingCart } from 'react-icons/md';
import { usePathname } from 'next/navigation';

export const EshopButton = ({
  isGreenSolution,
  isGreenWall,
  isEcoraster,
}: {
  isGreenSolution?: boolean;
  isGreenWall?: boolean;
  isEcoraster?: boolean;
}) => {
  return (
    <Button asChild variant={'secondary'}>
      <Link
        prefetch={false}
        href={
          isGreenSolution
            ? '/nadrze-na-dazdovu-a-odpadovu-vodu'
            : isGreenWall
            ? '/vegetacny-oporny-mur-ECOBAG?page=1'
            : isEcoraster
            ? '/drenazna-a-zatravnovacia-dlazba?page=1'
            : '/kategorie'
        }
      >
        <MdOutlineShoppingCart size={20} />
        <p>Eshop</p>
      </Link>
    </Button>
  );
};
